import { useEffect } from 'react';
import { useMapInstance } from 'shared/map-exports';
import { DEFAULT_VIEW_STATE } from 'features/mapping/mapping.constants';
import { hasValidCoordinates } from 'shared/utils';

type DynamicMapCenterProps = {
  lat?: number | null;
  lng?: number | null;
  zoom?: number;
  mapId?: string;
};

export const DynamicMapCenter = (props: DynamicMapCenterProps): null => {
  const { lat, lng, zoom = DEFAULT_VIEW_STATE.minZoom, mapId } = props;
  const map = useMapInstance(mapId);

  useEffect(() => {
    const coords = { lat, lng };
    if (!map || !hasValidCoordinates(coords)) {
      return;
    }

    const centerMap = (): void => {
      map.easeTo({ center: [coords.lng, coords.lat], zoom });
    };

    if (map.loaded()) {
      centerMap();
      return;
    }

    map.once('load', centerMap);
  }, [lat, lng, map, zoom]);

  return null;
};
